import React, { useRef, useState } from "react";
import ReactLoading from "react-loading";
import styled from "styled-components";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import PencilIcon from "@icons/EditPencilIcon.svg";
import { updateUserAviImg } from "@user/service/UserService";
import UserAvatar from "../../UserAvatar/UserAvatar";

const AviEl = styled(UserAvatar)``;

const EditIcon = styled(PencilIcon)`
    fill: white;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    position: absolute;
`;

const EditIconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    position: absolute;
    visibility: hidden;
    height: 100%;
    width: 100%;
    margin: auto;

    background-color: black;
    border-radius: 50%;
`;

const AviImgWrapper = styled.div`
    position: relative;
    transition: opacity 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:hover {
        opacity: 0.7;

        ${EditIconWrapper} {
            visibility: visible;
            opacity: 0.7;

            ${EditIcon} {
                opacity: 1;
            }
        }
    }
`;

const AviWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    height: auto;
    width: 50px;
    margin-top: 10px;

    border-radius: 50%;
    cursor: pointer;
`;

const UploadInput = styled.input``;

interface UserCustomAviUrlProps {}
function UserCustomAvi(props: UserCustomAviUrlProps) {
    const { user, userData }: UserContextType = useUserContext();

    const [isLoading, setIsLoading] = useState(false);

    const inputFile = useRef<HTMLInputElement | null>(null);

    const isUsingCustomAvi: boolean = userData?.customAviUrl?.length > 0;

    const handleClickToEditImage = () => {
        inputFile.current.click();
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files[0];
        setIsLoading(true);
        updateUserAviImg(user.uid, file, () => setIsLoading(false));
    };

    return (
        userData && (
            <AviWrapper onClick={handleClickToEditImage}>
                {isLoading && <ReactLoading type={"spokes"} color={"#E39685"} height={30} width={30} />}
                {!isLoading && (
                    <AviImgWrapper>
                        <AviEl
                            size={"medium"}
                            userDisplayName={userData?.displayName}
                            userAviUrl={isUsingCustomAvi ? userData.customAviUrl : user.photoURL}
                        />
                        <EditIconWrapper>
                            <EditIcon height={"30"} width={"30"} viewBox={"0 0 16 16"} />
                        </EditIconWrapper>
                    </AviImgWrapper>
                )}

                <UploadInput
                    id={"profileImgFile"}
                    type={"file"}
                    ref={inputFile}
                    accept={"image/*"}
                    style={{ display: "none" }}
                    onChange={handleChange}
                />
            </AviWrapper>
        )
    );
}

export default UserCustomAvi;
